import { render, staticRenderFns } from "./SinglePageToHomeRedirect.vue?vue&type=template&id=5767a6aa&scoped=true"
import script from "./SinglePageToHomeRedirect.vue?vue&type=script&lang=js"
export * from "./SinglePageToHomeRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5767a6aa",
  null
  
)

export default component.exports